import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "exclaimation-circle2--sprite",
  "use": "exclaimation-circle2--sprite-usage",
  "viewBox": "0 0 68 68",
  "content": "<symbol viewBox=\"0 0 68 68\" xmlns=\"http://www.w3.org/2000/svg\" id=\"exclaimation-circle2--sprite\">\n<path d=\"M33.9998 5.66663C18.3598 5.66663 5.6665 18.36 5.6665 34C5.6665 49.64 18.3598 62.3333 33.9998 62.3333C49.6398 62.3333 62.3332 49.64 62.3332 34C62.3332 18.36 49.6398 5.66663 33.9998 5.66663ZM36.8332 48.1666H31.1665V42.5H36.8332V48.1666ZM36.8332 36.8333H31.1665V19.8333H36.8332V36.8333Z\" fill=\"#007BFF\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol